import { IdentityRepositoryInterface } from "../identity-repositories";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { LocalStorage, Logger, LoggerTransformer } from "@identity/utils";
import { UUID } from "@identity/symbols";

@singleton()
export class LocalStorageRepository implements IdentityRepositoryInterface {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "UserIdentity")
    private logger: Logger,
    @inject(UUID) private uuid: () => string,
    @inject(LocalStorage) private storage: LocalStorage
  ) {}

  get(): Promise<string> {
    return Promise.resolve(this.storage.getItem("ppid") || this.generatePPID());
  }

  private generatePPID(): string {
    this.logger.info("did not found a PPID in LocalStorage");
    const ppid: string = this.uuid();
    this.storage.setItem("ppid", ppid);
    return ppid;
  }
}
